module.exports = __webpack_public_path__ + "media/images/home/doordash-4550dfd4ee7173ca8d16dc27493aeb7e.png";